import { IdNameModel } from "./IdNameModel";

export default class IdNameWithImgModel extends IdNameModel {
    imgSrc: string = ''
}